/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'g_environment': {
    width: 16,
    height: 16,
    viewBox: '0 0 56.97 56.69',
    data: '<path pid="0" d="M29.09 56.69C13.09 56.69 0 43.97 0 28.34S13.05 0 29.09 0a29.23 29.23 0 0122.87 10.82l-2.89 2.21a25.54 25.54 0 00-19.98-9.45c-14.02 0-25.37 11.11-25.37 24.76s11.4 24.77 25.42 24.77a25.7 25.7 0 0020.58-10.34l3 2.09a29.42 29.42 0 01-23.63 11.83" _fill="#fff"/><path pid="1" d="M17.19 38.01l-3.47-1.13c.14-.4 3.46-9.84 12.75-12.46s14.62.57 14.85.71l-1.92 3.05c-.16-.09-4.42-2.44-11.92-.33S17.22 37.93 17.19 38.01" _fill="#fff"/><path pid="2" d="M31.54 36.16a12.62 12.62 0 01-3.49-.52c-7.11-2-7.78-5.69-7.83-6.1l3.64-.44a.45.45 0 000-.11s.56 1.91 5.22 3.22c3 .83 4.55.18 7.14-.9a35 35 0 015.05-1.73 22.63 22.63 0 019.17 0c-1.9-3.48-4.95-8-8.22-9.3a18 18 0 00-16.75 1.61l-2.22-2.84a21.68 21.68 0 0120.38-2.07c6.86 2.77 11.63 14.09 11.83 14.57l1.51 3.62-3.8-1.25c-.06 0-6.28-2-11-.87a31.38 31.38 0 00-4.53 1.53 15.1 15.1 0 01-6.1 1.56" _fill="#fff"/>'
  }
})
